// src/App.js
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./components/SEO";
import Layout from "./components/Layout/Layout";
import Hero from "./components/Hero";
import Sobre from "./components/Sobre";
import Clientes from "./components/Clientes";
import Depoimentos from "./components/Depoimentos";
import Servicos from "./components/Servicos";
import "./index.css";

function App() {
  return (
    <HelmetProvider>
      <SEO
        title="Yvinna Patrícia - Consultoria de Imagem e Estilo"
        description="Eleve sua autoestima e confiança com a consultoria de imagem e estilo de Yvinna Patrícia. Especialista em coloração pessoal, estilo e personal shopper."
        name="Yvinna Patrícia"
        type="website"
        favicon="favicon.ico"
      />
      <div className="App">
        <Layout>
          <Hero />
          <Sobre />
          <Clientes />
          <Depoimentos />
          <Servicos />
        </Layout>
      </div>
    </HelmetProvider>
  );
}

export default App;
